import { Id } from "src/utils/types";
import { request } from "."

export type EezycoinOffering = {
  id: Id,
  created_at: string,
  updated_at: string,
  fk_created_by_user_id: number,
  fk_updated_by_user_id: number,
  fk_company_id: number,
  title: string,
  description: string,
  is_bundle: boolean,
  is_active: boolean,
  is_eezyfamily_offer: boolean,
  coins_included: number,
  value_per_coin_cents: number,
  total_value_cents: number,
}

export type CreateEezycoinOfferingPayload = Pick<
  EezycoinOffering,
  'title' | 'coins_included' | 'is_active' | 'is_eezyfamily_offer' | 'description'
> & {
  company_id: number | null,
  total_value: number,
}

export type UpdateEezycoinOfferingPayload = Pick<
  CreateEezycoinOfferingPayload,
  'title' | 'description' | 'is_active'
> & {
};

export type EezycoinWallet = {
  id: Id,
  created_at: string,
  updated_at: string
  owner_id: string,
  owner_type: 'COLABORATOR',
  type: 'PERSONAL',
  coin_balance: number,
  frozen_coin_balance: number,
  total_coin_balance: number,
}

export async function getEezycoinOfferings(): Promise<EezycoinOffering[]> {
  const response = await request.get(`/api/admin/eezycoin/offerings`)

  return response.data
}

export async function getEezycoinOfferingById(id: Id): Promise<EezycoinOffering|null> {
  const response = await request.get(`/api/admin/eezycoin/offerings/${id}`)

  if (response.data) {
    return response.data
  }

  return null
}

export async function createEezycoinOffering(payload: CreateEezycoinOfferingPayload): Promise<void> {
  await request.post(`/api/admin/eezycoin/offerings`, payload)
}

export async function updateEezycoinOffering(id: Id, payload: UpdateEezycoinOfferingPayload): Promise<void> {
  await request.put(`/api/admin/eezycoin/offerings/${id}`, payload)
}

export async function getWalletsByOwnerId(ownerId: Id): Promise<EezycoinWallet[]> {
  const response = await request.get(`/api/admin/eezycoin/wallets/owners/${ownerId}`)

  if (response.data) {
    return response.data
  }

  return []
}

export async function setupPersonalWalletForOwner(ownerId: Id, ownerType: string): Promise<EezycoinWallet> {
  const response = await request.put(`/api/admin/eezycoin/wallets/owners/${ownerId}/setup`, {
    wallet_type: 'PERSONAL',
    owner_type: ownerType,
  })

  return response.data
}

export async function adjustWalletBalance(walletId: Id, adjustedBalance: number, originalBalance: number): Promise<void> {
  await request.post(`/api/admin/eezycoin/wallets/${walletId}/adjust-balance`, {
    'adjusted_balance': adjustedBalance,
    'original_balance': originalBalance,
  })
}
